<template>
  <q-input
    @input="handleInput"
    v-model="model"
    v-validate.disable="validationRules"
    name="salesTax"
    type="number"
    min="0"
    max="100"
    suffix="&nbsp;%"
    :placeholder="$t('sales_tax')"
    v-bind="$attrs"
  >
    <q-autocomplete
      :static-data="{ field: 'label', list: salesTaxRates }"
      :min-characters="0"
      @show="$emit('show')"
      @hide="$emit('hide')"
    />
  </q-input>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { general } from 'src/config'

  export default {
    inject: ['$validator'],

    props: {
      value: {
        type: [Number, String],
        required: false
      },

      required: {
        type: Boolean,
        default: false
      },

      useDefault: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        model: this.value
      }
    },

    computed: {
      ...mapGetters(['activeTeam', 'lastSalesTax']),

      validationRules () {
        return this.required ? 'required|decimal:2' : 'decimal:2'
      },

      salesTaxRates () {
        return general.sales_tax_rates.map(rate => ({ value: rate, label: `${rate} %` }))
      }
    },

    methods: {
      ...mapActions(['setLastSalesTax']),

      handleInput (value) {
        this.$emit('input', value)
      },

      resetDefault () {
        if (this.useDefault && this.activeTeam.settings.is_small_business) {
          this.$emit('input', 0)
        } else if (this.useDefault && this.lastSalesTax) {
          this.$emit('input', this.lastSalesTax)
        }
      }
    },

    created () {
      if (!this.model) {
        this.resetDefault()
      }
    },

    watch: {
      value (newValue) {
        this.model = newValue
        this.setLastSalesTax(newValue)
      }
    }
  }
</script>
